<template>
    <section class="text">
        <p>
            {{ text }}
        </p>
    </section>
</template>
<script>
export default {
    name: 'SectionText',
    props: {
        text: {
            type: String,
            default: '',
        },
    },
};
</script>
<style lang="scss" scoped>
section.text {
    text-align: center;
}
</style>
